module.exports = __webpack_public_path__ + "img/lipigo_4.b5c2d15d.png";